module.exports = {"360202001":"西郊街道","360202002":"新枫街道","360202101":"鲇鱼山镇","360202102":"丽阳镇","360202202":"荷塘乡","360202290":"吕蒙乡","360202451":"昌江化工园区","360202452":"六零二所高科技园","360202453":"昌江开发区","360202500":"枫树山总场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360202.json
// module id = 1255
// module chunks = 0